import { render, staticRenderFns } from "./itemInventoryAssembly.vue?vue&type=template&id=45357a9e&scoped=true&"
import script from "./itemInventoryAssembly.vue?vue&type=script&lang=js&"
export * from "./itemInventoryAssembly.vue?vue&type=script&lang=js&"
import style0 from "./itemInventoryAssembly.vue?vue&type=style&index=0&id=45357a9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45357a9e",
  null
  
)

export default component.exports